import { useMemo } from 'react';

const useDataMatch = <T>(data: T, match: T[]) => useMemo(() => match.includes(data), [data, match]);

export default useDataMatch;
